


export class SymbolDataStopped {
    public level:number = -1;
    public multiplierString:string = "";
    public symbolMultipliers:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
        M1: -1,
        M2: -1,
        M3: -1,
        M4: -1,
        M5: -1,
    };
    public symbolsToM1:string [] = [];
    public currentMode:string = "";
    public collectedAfter:number = -1;
    public collectedBefore:number = -1;
    public isFilled:boolean = false;
    public lastMultiplier :number = 1;


    constructor() {}

    // TODO: Symbols to M1, symbols are replaced. Server
    public determineTransform(symName:string):boolean {
        const bool:boolean = (this.symbolsToM1.indexOf(symName) > -1);

        if(symName === "M1") {
            return false;
        }


        if((this.symbolsToM1.length > 0 || this.collectedAfter >= 5) && (this.currentMode === "FREESPIN_TRANSFORM" || this.currentMode === "FREESPIN_COMBINED")) {

            if(bool) {
                //console.log("------------------ TRANSFORM ON SYM: " + symName);
                return bool;
            }
        }

        return false;
    }

    symbolCollectedIncrement(collectedBefore:number  = -1, collectedAfter:number = -1):boolean {
        const bool:boolean = false;
        let indicatorLevel:number =  -1;

        // Todo: Determine current level
        if(collectedBefore > -1 && collectedBefore < 5) {
            indicatorLevel = 0;
        }
        else if(collectedBefore > -1 && collectedBefore < 10) {
            indicatorLevel = 1;
        }
        else if(collectedBefore > -1 && collectedBefore < 15) {
            indicatorLevel = 2;
        }
        else if(collectedBefore > -1 && collectedBefore < 20) {
            indicatorLevel = 3;
        }
        else if(collectedBefore > -1 && collectedBefore > 20) {
            indicatorLevel = 4;
        }

        // Todo: Determine if level increment, (for indicators and symbols)


        return bool;
    }

    public determineMultiplier(symName:string):number {
        //let nr:number
        //debugger;

        // TODO: if symbolCollected reaches next level, increase multiplier by one.



        if(this.symbolMultipliers && (this.currentMode === "FREESPIN_MULTIPLIER" || this.currentMode === "FREESPIN_COMBINED") && ["M1", "M2", "M3", "M4", "M5"].indexOf(symName) > -1) {
            switch(symName) {
                case "M1":
                    return this.symbolMultipliers.M1;
                case "M2":
                    return this.symbolMultipliers.M2;
                case "M3":
                    return this.symbolMultipliers.M3;
                case "M4":
                    return this.symbolMultipliers.M4;
                case "M5":
                    return this.symbolMultipliers.M5;
            }

            //return this.symbolMultipliers[symName];
        }

        return -1;
    }

    public reset():void {
        this.level = -1;
        this.multiplierString = "";
        this.symbolMultipliers = {
            M1: -1,
            M2: -1,
            M3: -1,
            M4: -1,
            M5: -1,
        };

        // TODO: symbolsToM1: use
        this.symbolsToM1 = [];
        this.currentMode = "";
    }
}